import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { HttpService } from '@services/http.service';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { EndpointParams } from '@models/utils/endpoint-params';
import { MemberIdentificationType } from '@enumerates/member/member-identification-type';

@Injectable({
    providedIn: 'root'
})
export class MemberService extends HttpService {
    private readonly defaultEndpointParams: EndpointParams = { app: 'member', version: 1 };

    checkNif(nif: string, publicToken: string, identificationType: MemberIdentificationType): Observable<{ value: boolean }> {
        return this.post(`members/nif/check?centerToken=${publicToken}`, { app: 'member', version: 3 }, { nif, identificationType }, this.noShowErrorNotification);
    }

    checkNifAuthenticated(nif: string, identificationType: MemberIdentificationType): Observable<{ value: boolean }> {
        return this.post('customer/members/nif/check', { app: 'member', version: 3 }, { nif, identificationType }, this.noShowErrorNotification);
    }

    exist(email: string, publicToken: string, language: string): Observable<boolean> {
        const params = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', showErrorMessage: 'false' }),
            params: new HttpParams().set('email', email).set('centerToken', publicToken)
        };

        return this.get2(`members/exist?language_code=${language}`, this.defaultEndpointParams, params);
    }
}
